import axios from "axios";

export const state = {
    studentpromotes: [],
};

export const getters = {
    studentpromotes: state => state.studentpromotes,
};

export const mutations = {
    setStudents(state, newValue) {
        state.studentpromotes = newValue
    },
};

export const actions = {
    fetchStudents({commit}, {schoolterm,year,schoolclass,schoolstream}) { 
        let formData = new FormData();
        formData.append("schoolterm", schoolterm);
        formData.append("year", year);
        formData.append("schoolclass", schoolclass);
        formData.append("schoolstream", schoolstream);
        let url = "studentpromotes";
        axios.post(url, formData).then((response) => {
            commit('setStudents', response.data.students)
        })
    },

    addStudents({commit}, {schoolterm,year,schoolclass,schoolstream}) { 
        let formData = new FormData();
        formData.append("schoolterm", schoolterm);
        formData.append("year", year);
        formData.append("schoolclass", schoolclass);
        formData.append("schoolstream", schoolstream);
        let url = "/addstudentpromotes";
        axios.post(url, formData).then((response) => {
            commit('setStudents', response.data.students)
        })
    },
};
